export default __webpack_public_path__ + "static/media/DNo.4-2.c7b2e73e.jpg";